

$('.testimonial-slider-wrapper').slick({
  centerMode: true,
  adaptiveHeight: false, 
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  swipeToSlide: true,
  arrows: false,
  draggable: false,
  autoplaySpeed: 5000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        infinite: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: true,
        dots: true,
        autoplaySpeed: 2000
      }
    }
  ]
});

// $('.drag-slider__slide').slick({
//   dots: true,
//   infinite: false,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: true,
//   draggable: false,
//   swipeToSlide: false,
//   responsive: [
//     {
//       breakpoint: 1400,
//       settings: {
//         arrows: false
//       }
//     }
//   ]
// });

$('.testimonial__slide').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipeToSlide: true,
  arrows: false,
  draggable: true,
  dots: false
});

$('.blog-slider__slider').slick({
  centerMode: false,
  centerPadding: '80px',
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  responsive: [
    {
      breakpoint: 1601,
      settings: {
        centerMode: false,
        centerPadding: '80px',
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1441,
      settings: {
        centerMode: false,
        centerPadding: '80px',
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1201,
      settings: {
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 991,
      settings: {
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 590,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});

$('.blog-slider__slider_full_width').slick({
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  variableWidth: true,
  nextArrow: $('.slick-controls .previous'),
  prevArrow: $('.slick-controls .next'),
  responsive: [
    {
      breakpoint: 1601,
      settings: {
        centerMode: false,
        centerPadding: '80px',
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1441,
      settings: {
        centerMode: false,
        centerPadding: '80px',
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1201,
      settings: {
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 991,
      settings: {
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 590,
      settings: {
        arrows: true,
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});

$('.ugc_wrapper').slick({
  centerMode: true,
  centerPadding: '0px',
  slidesToShow: 5, 
  draggable:false,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: true,
  speed: 600,
  cssEase: 'ease',
  variableWidth: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '00px',
        slidesToShow: 1
      }
    }
  ]
});

jQuery(document).ready(function($){
  var dragging = false,
      scrolling = false,
      resizing = false;
  //cache jQuery objects
  var imageComparisonContainers = $('.cd-image-container');
  //check if the .cd-image-container is in the viewport 
  //if yes, animate it
  checkPosition(imageComparisonContainers);
  $(window).on('scroll', function(){
      if( !scrolling) {
          scrolling =  true;
          ( !window.requestAnimationFrame )
              ? setTimeout(function(){checkPosition(imageComparisonContainers);}, 100)
              : requestAnimationFrame(function(){checkPosition(imageComparisonContainers);});
      }
  });
  
  //make the .cd-handle element draggable and modify .cd-resize-img width according to its position
  imageComparisonContainers.each(function(){
    var actual = $(this);
    drags(actual.find('.cd-handle'), actual.find('.cd-resize-img'), actual, actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-image-label[data-type="modified"]'), actual);
  });        

  //upadate images label visibility
  $(window).on('resize', function(){
      if( !resizing) {
          resizing =  true;
          ( !window.requestAnimationFrame )
              ? setTimeout(function(){checkLabel(imageComparisonContainers);}, 100)
              : requestAnimationFrame(function(){checkLabel(imageComparisonContainers);});
      }
  });

  function checkPosition(container) {
      container.each(function(){
          var actualContainer = $(this);
          if( $(window).scrollTop() + $(window).height()*0.5 > actualContainer.offset().top) {
              actualContainer.addClass('is-visible');
          }
      });

      scrolling = false;
  }

  function checkLabel(container) {
      container.each(function(){
          var actual = $(this);
          updateLabel(actual.find('.cd-image-label[data-type="modified"]'), actual.find('.cd-resize-img'), 'left');
          updateLabel(actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-resize-img'), 'right');
      });

      resizing = false;
  }

  //draggable funtionality - credits to http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/
  function drags(dragElement, resizeElement, container, labelContainer, labelResizeElement) {
    dragElement.on("mousedown vmousedown", function(e) {
      var dragElement = $(this); // Get the specific handle element that was clicked
      dragElement.addClass('draggable');
      resizeElement.addClass('resizable');
  
      var dragWidth = dragElement.outerWidth(),
        xPosition = dragElement.offset().left + dragWidth - e.pageX,
        containerOffset = container.offset().left,
        containerWidth = container.outerWidth(),
        minLeft = containerOffset + 10,
        maxLeft = containerOffset + containerWidth - dragWidth - 10;
  
      $(document).on("mousemove vmousemove", function(e) {
        if (!dragging) {
          dragging = true;
          (!window.requestAnimationFrame)
            ? setTimeout(function() {
              animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);
            }, 100)
            : requestAnimationFrame(function() {
              animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);
            });
        }
      }).on("mouseup vmouseup", function(e) {
        dragElement.removeClass('draggable');
        resizeElement.removeClass('resizable');
      });
      e.preventDefault();
    }).on("mouseup vmouseup", function(e) {
      dragElement.removeClass('draggable');
      resizeElement.removeClass('resizable');
    });
  }
  

  function animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement) {
      var leftValue = e.pageX + xPosition - dragWidth;   
      //constrain the draggable element to move inside his container
      if(leftValue < minLeft ) {
          leftValue = minLeft;
      } else if ( leftValue > maxLeft) {
          leftValue = maxLeft;
      }

      var widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';
      
      $('.draggable').css('left', widthValue).on("mouseup vmouseup", function() {
          $(this).removeClass('draggable');
          resizeElement.removeClass('resizable');
      });

      $('.resizable').css('width', widthValue); 

      updateLabel(labelResizeElement, resizeElement, 'left');
      updateLabel(labelContainer, resizeElement, 'right');
      dragging =  false;
  }

  function updateLabel(label, resizeElement, position) {
    label.toggleClass('is-hidden', position === 'left' ? 
        label.offset().left + label.outerWidth() >= resizeElement.offset().left + resizeElement.outerWidth() :
        label.offset().left <= resizeElement.offset().left + resizeElement.outerWidth()
    );
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const accordionButtons = document.querySelectorAll('.accordion-button');

  accordionButtons.forEach(button => {
    button.addEventListener('click', function() { 
      const content = this.nextElementSibling;
      
      // Toggle the .show class to handle the transition
      content.classList.toggle('show');

      const icon = this.querySelector('.icon');
      icon.textContent = icon.textContent === '+' ? '-' : '+';
    });
  });
});

$(document).ready(function() {
  // Initially open the first item
  $('.module-faq__item-container .module-faq__item:nth-child(1) .module-faq__question-container').addClass('active');
  $('.module-faq__item-container .module-faq__item:nth-child(1) .module-faq__answer-container').slideDown();
  $('.module-faq__item-container .module-faq__item:nth-child(1) .plus').hide();
  $('.module-faq__item-container .module-faq__item:nth-child(1) .minus').show();

  $('.module-faq__question-container').on('click', function() {
      // Check if the clicked item already has the active class
      if (!$(this).hasClass('active')) {
          // If not, close all answers and remove active class from all questions
          $('.module-faq__answer-container').slideUp();
          $('.module-faq__question-container').removeClass('active');
          $('.plus').show();
          $('.minus').hide();

          // Then, open the clicked item
          $(this).siblings('.module-faq__answer-container').slideDown();
          $(this).addClass('active');
          $(this).find('.plus').hide();
          $(this).find('.minus').show();
      }
  });
});


$('.mission-slider-wrapper').slick({
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  swipeToSlide: true,
  arrows: true,
  draggable: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
});

$('.icon-slider-wrapper').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  swipeToSlide: true,
  arrows: true,
  draggable: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true
      }
    }
  ]
});

$('.dummy_insta_image').slick({
  centerMode: true,
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  swipeToSlide: true,
  arrows: false,
  draggable: false,
  autoplay: true,
  autoplaySpeed: 2000,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false
      }
    }
  ]
});
